import * as components from './components'
import { locales } from './locales'
import { repositories } from './repositories'
import { services } from './services'
import { stores } from './stores'

// TEST: init.app-ts vs init.app, необходимы npx nuxi cleanup и перезагрузка ide
export { GaApp } from './core/app-ts'
// export { GaApp } from './core/app'

export { replaceAbsoluteHref } from './helpers/replaceAbsoluteHref.js'

export {
  useAppRouter,
  useAppWindowStore,
  useDeviceOrientationType,
} from './composables'

export { COUNTRY, LANGUAGE } from './constant'

export { useApp } from './composables/app'

export * from './core/types'

export const app = {
  meta: {
    name: 'app' as const,
    locales,
  },
  components,
  layers: {
    stores,
    services,
    repositories,
  },
}

export { mediaQueryInstance } from './helpers/mediaQuery'
export { GaMobileOnlyStub } from './components/mobile-only-stub'
